// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../Assets/Images/banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0%, 30%, 50%, 70%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
}
.pro-sidebar {
  color: #adadad;
  height: 100%;
  width: 270px;
  min-width: 270px;
  text-align: left;
  transition: width, left, right, 0.3s;
  position: relative;
  z-index: 1009;
}
.pro-sidebar > .pro-sidebar-inner {
  background: #1d1d1d;
  height: 100%;
  position: relative;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 100;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 1;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pro-sidebar .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: none;
}
.pro-sidebar.collapsed {
  width: 80px;
  min-width: 80px;
}
.pro-sidebar.rtl {
  text-align: right;
  direction: rtl;
}
@media (max-width: 480px) {
  .pro-sidebar.xs {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xs.collapsed {
    left: -80px;
  }
  .pro-sidebar.xs.toggled {
    left: 0;
  }
  .pro-sidebar.xs.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xs.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xs.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xs.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 576px) {
  .pro-sidebar.sm {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.sm.collapsed {
    left: -80px;
  }
  .pro-sidebar.sm.toggled {
    left: 0;
  }
  .pro-sidebar.sm.toggled .overlay {
    display: block;
  }
  .pro-sidebar.sm.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.sm.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.sm.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 768px) {
  .pro-sidebar.md {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.md.collapsed {
    left: -80px;
  }
  .pro-sidebar.md.toggled {
    left: 0;
  }
  .pro-sidebar.md.toggled .overlay {
    display: block;
  }
  .pro-sidebar.md.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.md.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.md.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 992px) {
  .pro-sidebar.lg {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.lg.collapsed {
    left: -80px;
  }
  .pro-sidebar.lg.toggled {
    left: 0;
  }
  .pro-sidebar.lg.toggled .overlay {
    display: block;
  }
  .pro-sidebar.lg.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.lg.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.lg.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1200px) {
  .pro-sidebar.xl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xl.toggled {
    left: 0;
  }
  .pro-sidebar.xl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xl.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1600px) {
  .pro-sidebar.xxl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xxl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xxl.toggled {
    left: 0;
  }
  .pro-sidebar.xxl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xxl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xxl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xxl.rtl.toggled {
    left: auto;
    right: 0;
  }
}

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: "";
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid #2b2b2b;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #adadad, 0px -1px 0px #adadad, 0px 1px 0px #adadad, -1px 0px 0px #adadad;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  position: relative;
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pro-sidebar .pro-menu a {
  text-decoration: none;
  color: #adadad;
}
.pro-sidebar .pro-menu a:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
}
.pro-sidebar .pro-menu a:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
  display: flex;
  margin-right: 5px;
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 35px 8px 20px;
  cursor: pointer;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 10px;
  font-size: 14px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  background: #adadad;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #adadad;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.3s;
  transform: rotate(-45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  background: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 24px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  background: none;
  width: auto;
  min-width: auto;
  height: auto;
  line-height: auto;
}
.pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 0;
}
.pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 4px;
}
.pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 50%;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
  background-color: #2b2b2b;
  z-index: 111;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-left: 10px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background-color: #2b2b2b;
  padding-left: 20px;
  border-radius: 4px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility, transform 0.3s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 0;
  margin-left: 10px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(135deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 15px 8px 30px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  margin-right: 0;
  margin-left: 15px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-right: 10px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  padding-left: 0;
  padding-right: 20px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px;
}

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.popper-element[data-popper-placement^=left] > .popper-arrow {
  right: 0;
  border-right: 7px solid #2b2b2b;
}

.popper-element[data-popper-placement^=right] > .popper-arrow {
  left: 0;
  border-left: 7px solid #2b2b2b;
}

.react-slidedown {
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.react-slidedown.transitioning {
  overflow-y: hidden;
}

.react-slidedown.closed {
  display: none;
}

@keyframes swing {
  0%, 30%, 50%, 70%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
}
.pro-sidebar {
  color: #adadad;
  height: 100%;
  width: 270px;
  min-width: 270px;
  text-align: left;
  transition: width, left, right, 0.3s;
  position: relative;
  z-index: 1009;
}
.pro-sidebar > .pro-sidebar-inner {
  background: #1d1d1d;
  height: 100%;
  position: relative;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 100;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 1;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pro-sidebar .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: none;
}
.pro-sidebar.collapsed {
  width: 80px;
  min-width: 80px;
}
.pro-sidebar.rtl {
  text-align: right;
  direction: rtl;
}
@media (max-width: 480px) {
  .pro-sidebar.xs {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xs.collapsed {
    left: -80px;
  }
  .pro-sidebar.xs.toggled {
    left: 0;
  }
  .pro-sidebar.xs.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xs.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xs.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xs.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 576px) {
  .pro-sidebar.sm {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.sm.collapsed {
    left: -80px;
  }
  .pro-sidebar.sm.toggled {
    left: 0;
  }
  .pro-sidebar.sm.toggled .overlay {
    display: block;
  }
  .pro-sidebar.sm.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.sm.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.sm.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 768px) {
  .pro-sidebar.md {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.md.collapsed {
    left: -80px;
  }
  .pro-sidebar.md.toggled {
    left: 0;
  }
  .pro-sidebar.md.toggled .overlay {
    display: block;
  }
  .pro-sidebar.md.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.md.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.md.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 992px) {
  .pro-sidebar.lg {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.lg.collapsed {
    left: -80px;
  }
  .pro-sidebar.lg.toggled {
    left: 0;
  }
  .pro-sidebar.lg.toggled .overlay {
    display: block;
  }
  .pro-sidebar.lg.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.lg.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.lg.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1200px) {
  .pro-sidebar.xl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xl.toggled {
    left: 0;
  }
  .pro-sidebar.xl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xl.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1600px) {
  .pro-sidebar.xxl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xxl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xxl.toggled {
    left: 0;
  }
  .pro-sidebar.xxl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xxl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xxl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xxl.rtl.toggled {
    left: auto;
    right: 0;
  }
}

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: "";
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid #2b2b2b;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #adadad, 0px -1px 0px #adadad, 0px 1px 0px #adadad, -1px 0px 0px #adadad;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  position: relative;
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pro-sidebar .pro-menu a {
  text-decoration: none;
  color: #adadad;
}
.pro-sidebar .pro-menu a:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
}
.pro-sidebar .pro-menu a:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
  display: flex;
  margin-right: 5px;
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 35px 8px 20px;
  cursor: pointer;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 10px;
  font-size: 14px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  background: #adadad;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #adadad;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.3s;
  transform: rotate(-45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  background: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 24px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  background: none;
  width: auto;
  min-width: auto;
  height: auto;
  line-height: auto;
}
.pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 0;
}
.pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 4px;
}
.pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 50%;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
  background-color: #2b2b2b;
  z-index: 111;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-left: 10px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background-color: #2b2b2b;
  padding-left: 20px;
  border-radius: 4px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility, transform 0.3s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 0;
  margin-left: 10px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(135deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 15px 8px 30px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  margin-right: 0;
  margin-left: 15px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-right: 10px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  padding-left: 0;
  padding-right: 20px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px;
}

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.popper-element[data-popper-placement^=left] > .popper-arrow {
  right: 0;
  border-right: 7px solid #2b2b2b;
}

.popper-element[data-popper-placement^=right] > .popper-arrow {
  left: 0;
  border-left: 7px solid #2b2b2b;
}

.react-slidedown {
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.react-slidedown.transitioning {
  overflow-y: hidden;
}

.react-slidedown.closed {
  display: none;
}

.login_height {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 5%;
}

.background_image_login {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.heading_login {
  font-size: 32px;
  font-family: "Poppins";
  padding-top: 12%;
  font-weight: 400;
  color: #fff;
}

.heading2_login {
  font-size: 50px;
  font-family: "Poppins";
  font-weight: 500;
  line-height: 115%;
  color: #fff;
  text-transform: uppercase;
}

.heading3_login {
  font-size: 28px;
  font-family: "Poppins";
  font-weight: 400;
  line-height: 115%;
  color: #fff;
}

.heading4_login {
  padding-top: 5%;
  color: #131313;
  font-weight: 1000 !important;
  font-size: 26px;
}

.heading5_login {
  font-weight: 400 !important;
  font-size: 20px;
  color: Gray;
}

.label_login {
  font-size: 12px;
  color: Gray;
  font-weight: 400 !important;
}

.join_login {
  font-size: 12px;
  color: Gray;
  font-weight: 400 !important;
}

.join2_login {
  font-size: 12px;
  color: #0575E6;
  font-weight: 400 !important;
}

.button_linkedin {
  font-size: 22px;
}

.mob_logo {
  display: none;
}

.link_decoration {
  text-decoration: none;
}

.text_color_line {
  color: #131313;
}

.right_arrow_login1 {
  color: #131313;
  font-weight: 300 !important;
}

.img_width_login {
  width: 100%;
}

.img_bulb_width {
  width: 3.5%;
}

.button_style_forget {
  border: 1px solid lightgray;
  background-color: white;
}

.button_style_forget:hover {
  background-color: white;
  border: none;
  box-shadow: 4px 4px 6px 6px rgba(128, 128, 128, 0.213);
}

.custom_button_forget {
  background-color: #25224A !important;
  border-top-left-radius: 1px !important;
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
  font-size: 80%;
  width: 100%;
  padding: 10px 10px !important;
  border-top-right-radius: 10px;
}

.custom_button_forget:hover {
  background-color: #25224A !important;
  border-top-left-radius: 1px !important;
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
  font-size: 80%;
  width: 100%;
}

.mobile_padding_bottom_forget {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}

@media screen and (max-width: 980px) {
  .login_height {
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .background_image_login {
    display: none;
  }
  .heading4_login {
    padding-top: 20%;
    color: #131313;
    font-weight: 700 !important;
    font-size: 26px;
  }
  .mob_logo {
    padding-top: 30% !important;
    display: block;
  }
  .mobile_padding_bottom {
    padding-bottom: 15% !important;
  }
  .button_style_forget {
    margin-top: 30%;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_animation.scss","webpack://./src/Pages/Auth/Resetpassword/Resetpassword.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_sidebar.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/variables.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_menu.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_popperArrow.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_reactSlidedown.scss","webpack://./src/Assets/Scss/veriables.scss"],"names":[],"mappings":"AAAA;EACE;IAKE,uBAAA;ECCF;EDEA;IACE,wBAAA;ECAF;EDGA;IACE,yBAAA;ECDF;EDIA;IACE,uBAAA;ECFF;EDKA;IACE,wBAAA;ECHF;AACF;ACMA;EACE,cC1Bc;ED2Bd,YAAA;EACA,YC3Bc;ED4Bd,gBC5Bc;ED6Bd,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;ADJF;ACKE;EACE,mBCpCe;EDqCf,YAAA;EACA,kBAAA;EACA,YAAA;ADHJ;ACKI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;ADHN;ACMI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ADJN;ACMM;EACE,iDAAA;ADJR;ACMM;EACE,YAAA;ADJR;ACMM;EACE,8CAAA;ADJR;ACMM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;ADJR;ACSE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;ADPJ;ACUE;EACE,WCxFsB;EDyFtB,eCzFsB;AFiF1B;ACWE;EACE,iBAAA;EACA,cAAA;ADTJ;ACaI;EADF;IAnGA,eAAA;IACA,YAAA;ED2FA;EC1FA;IACE,WAAA;ED4FF;EC1FA;IACE,OAAA;ED4FF;EC3FE;IACE,cAAA;ED6FJ;EC1FA;IACE,UAAA;IACA,aAAA;ED4FF;EC3FE;IACE,UAAA;IACA,YAAA;ED6FJ;EC3FE;IACE,UAAA;IACA,QAAA;ED6FJ;AACF;ACTI;EADF;IAxGA,eAAA;IACA,YAAA;EDsHA;ECrHA;IACE,WAAA;EDuHF;ECrHA;IACE,OAAA;EDuHF;ECtHE;IACE,cAAA;EDwHJ;ECrHA;IACE,UAAA;IACA,aAAA;EDuHF;ECtHE;IACE,UAAA;IACA,YAAA;EDwHJ;ECtHE;IACE,UAAA;IACA,QAAA;EDwHJ;AACF;AC/BI;EADF;IA7GA,eAAA;IACA,YAAA;EDiJA;EChJA;IACE,WAAA;EDkJF;EChJA;IACE,OAAA;EDkJF;ECjJE;IACE,cAAA;EDmJJ;EChJA;IACE,UAAA;IACA,aAAA;EDkJF;ECjJE;IACE,UAAA;IACA,YAAA;EDmJJ;ECjJE;IACE,UAAA;IACA,QAAA;EDmJJ;AACF;ACrDI;EADF;IAlHA,eAAA;IACA,YAAA;ED4KA;EC3KA;IACE,WAAA;ED6KF;EC3KA;IACE,OAAA;ED6KF;EC5KE;IACE,cAAA;ED8KJ;EC3KA;IACE,UAAA;IACA,aAAA;ED6KF;EC5KE;IACE,UAAA;IACA,YAAA;ED8KJ;EC5KE;IACE,UAAA;IACA,QAAA;ED8KJ;AACF;AC3EI;EADF;IAvHA,eAAA;IACA,YAAA;EDuMA;ECtMA;IACE,WAAA;EDwMF;ECtMA;IACE,OAAA;EDwMF;ECvME;IACE,cAAA;EDyMJ;ECtMA;IACE,UAAA;IACA,aAAA;EDwMF;ECvME;IACE,UAAA;IACA,YAAA;EDyMJ;ECvME;IACE,UAAA;IACA,QAAA;EDyMJ;AACF;ACjGI;EADF;IA5HA,eAAA;IACA,YAAA;EDkOA;ECjOA;IACE,WAAA;EDmOF;ECjOA;IACE,OAAA;EDmOF;EClOE;IACE,cAAA;EDoOJ;ECjOA;IACE,UAAA;IACA,aAAA;EDmOF;EClOE;IACE,UAAA;IACA,YAAA;EDoOJ;EClOE;IACE,UAAA;IACA,QAAA;EDoOJ;AACF;;AGzPE;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gGAAA;AH4PJ;;AGvPA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AH0PF;;AGtPE;EACE,iBAAA;EACA,oBAAA;AHyPJ;AGrPQ;EACE,kBAAA;EACA,yBD1BS;AFiRnB;AGrPU;EACE,iBAAA;EACA,oBAAA;AHuPZ;AGlPI;EACE,qBAAA;EACA,cDzCU;AF6RhB;AGnPM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AHqPR;AGnPM;EACE,cDjDU;AFsSlB;AGlPI;EACE,eAAA;AHoPN;AGnPM;EACE,cDvDU;AF4SlB;AGlPM;EACE,UAAA;EACA,wBAAA;AHoPR;AGlPM;EACE,aAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;AHoPR;AGjPM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AHmPR;AGjPQ;EACE,aAAA;EACA,cD9EQ;AFiUlB;AGjPQ;EACE,kBAAA;EACA,eAAA;EACA,WD/EE;ECgFF,eDhFE;ECiFF,YDjFE;ECkFF,iBDlFE;ECmFF,kBAAA;EACA,qBAAA;AHmPV;AGjPU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AHmPZ;AG/OQ;EACE,YAAA;EACA,cAAA;AHiPV;AG5OQ;EACE,cD1GQ;AFwVlB;AG5OY;EACE,6CAAA;AH8Od;AGtOU;EACE,mBDzHI;AFiWhB;AGrOU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AHuOZ;AGrOY;EACE,qBAAA;EACA,mBAAA;EACA,qBDrIE;ECsIF,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AHuOd;AGhOY;EACE,kCAAA;AHkOd;AG/Nc;EACE,wBAAA;AHiOhB;AG3NQ;EACE,kBDrJO;AFkXjB;AG3NU;EACE,0BAAA;AH6NZ;AG3NY;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AH6Nd;AGrNM;EACE,aAAA;AHuNR;AG3MU;EACE,yBDvLI;AFoYhB;AGpMU;EACE,gBAAA;AHsMZ;AG9LU;EACE,kBAAA;AHgMZ;AGxLU;EACE,kBAAA;AH0LZ;AG9KQ;EAWE,kBAAA;AHsKV;AG/KY;;EAEE,UAAA;AHiLd;AG9KU;EACE,yBDxOiB;ECyOjB,YAAA;AHgLZ;AG7KU;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AH+KZ;AG7KU;EACE,kBAAA;AH+KZ;AG7KY;EACE,oBAAA;AH+Kd;AG7Kc;EACE,aAAA;AH+KhB;AG5KY;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AH8Kd;AG7Kc;EACE,kBAAA;AH+KhB;AG7Kc;EACE,iBAAA;EACA,gBAAA;EACA,yBD/Qa;ECgRb,kBAAA;EACA,kBAAA;AH+KhB;AG3Kc;EACE,sCAAA;EACA,mBAAA;AH6KhB;AG1KgB;EACE,6CAAA;AH4KlB;AGtKc;;EAEE,yBAAA;AHwKhB;AG3JQ;EACE,eAAA;EACA,gBAAA;AH6JV;AG3JQ;EACE,0BAAA;AH6JV;AG5JU;EACE,eAAA;EACA,iBAAA;AH8JZ;AGxJY;EACE,WAAA;EACA,UAAA;AH0Jd;AGzJc;EACE,yBAAA;AH2JhB;AGpJgB;EACE,wBAAA;AHsJlB;AGhJU;EACE,eAAA;EACA,mBD/UK;AFiejB;AGhJY;EACE,0BAAA;AHkJd;AGjJc;EACE,eAAA;EACA,iBAAA;AHmJhB;AGrIc;EACE,eAAA;EACA,kBAAA;AHuIhB;AGtIgB;EACE,mBAAA;AHwIlB;AGtIgB;EACE,eAAA;EACA,mBAAA;AHwIlB;AGnIgB;;EAEE,yBAAA;AHqIlB;;AIhgBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;AJmgBF;;AIhgBA;EACE,QAAA;EACA,+BAAA;AJmgBF;;AIhgBA;EACE,OAAA;EACA,8BAAA;AJmgBF;;AKnhBA;EACE,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;ALshBF;;AKnhBA;EACE,kBAAA;ALshBF;;AKnhBA;EACE,aAAA;ALshBF;;ADliBA;EACE;IAKE,uBAAA;ECiiBF;ED9hBA;IACE,wBAAA;ECgiBF;ED7hBA;IACE,yBAAA;EC+hBF;ED5hBA;IACE,uBAAA;EC8hBF;ED3hBA;IACE,wBAAA;EC6hBF;AACF;AC1hBA;EACE,cC1Bc;ED2Bd,YAAA;EACA,YC3Bc;ED4Bd,gBC5Bc;ED6Bd,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;AD4hBF;AC3hBE;EACE,mBCpCe;EDqCf,YAAA;EACA,kBAAA;EACA,YAAA;AD6hBJ;AC3hBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;AD6hBN;AC1hBI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AD4hBN;AC1hBM;EACE,iDAAA;AD4hBR;AC1hBM;EACE,YAAA;AD4hBR;AC1hBM;EACE,8CAAA;AD4hBR;AC1hBM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AD4hBR;ACvhBE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;ADyhBJ;ACthBE;EACE,WCxFsB;EDyFtB,eCzFsB;AFinB1B;ACrhBE;EACE,iBAAA;EACA,cAAA;ADuhBJ;ACnhBI;EADF;IAnGA,eAAA;IACA,YAAA;ED2nBA;EC1nBA;IACE,WAAA;ED4nBF;EC1nBA;IACE,OAAA;ED4nBF;EC3nBE;IACE,cAAA;ED6nBJ;EC1nBA;IACE,UAAA;IACA,aAAA;ED4nBF;EC3nBE;IACE,UAAA;IACA,YAAA;ED6nBJ;EC3nBE;IACE,UAAA;IACA,QAAA;ED6nBJ;AACF;ACziBI;EADF;IAxGA,eAAA;IACA,YAAA;EDspBA;ECrpBA;IACE,WAAA;EDupBF;ECrpBA;IACE,OAAA;EDupBF;ECtpBE;IACE,cAAA;EDwpBJ;ECrpBA;IACE,UAAA;IACA,aAAA;EDupBF;ECtpBE;IACE,UAAA;IACA,YAAA;EDwpBJ;ECtpBE;IACE,UAAA;IACA,QAAA;EDwpBJ;AACF;AC/jBI;EADF;IA7GA,eAAA;IACA,YAAA;EDirBA;EChrBA;IACE,WAAA;EDkrBF;EChrBA;IACE,OAAA;EDkrBF;ECjrBE;IACE,cAAA;EDmrBJ;EChrBA;IACE,UAAA;IACA,aAAA;EDkrBF;ECjrBE;IACE,UAAA;IACA,YAAA;EDmrBJ;ECjrBE;IACE,UAAA;IACA,QAAA;EDmrBJ;AACF;ACrlBI;EADF;IAlHA,eAAA;IACA,YAAA;ED4sBA;EC3sBA;IACE,WAAA;ED6sBF;EC3sBA;IACE,OAAA;ED6sBF;EC5sBE;IACE,cAAA;ED8sBJ;EC3sBA;IACE,UAAA;IACA,aAAA;ED6sBF;EC5sBE;IACE,UAAA;IACA,YAAA;ED8sBJ;EC5sBE;IACE,UAAA;IACA,QAAA;ED8sBJ;AACF;AC3mBI;EADF;IAvHA,eAAA;IACA,YAAA;EDuuBA;ECtuBA;IACE,WAAA;EDwuBF;ECtuBA;IACE,OAAA;EDwuBF;ECvuBE;IACE,cAAA;EDyuBJ;ECtuBA;IACE,UAAA;IACA,aAAA;EDwuBF;ECvuBE;IACE,UAAA;IACA,YAAA;EDyuBJ;ECvuBE;IACE,UAAA;IACA,QAAA;EDyuBJ;AACF;ACjoBI;EADF;IA5HA,eAAA;IACA,YAAA;EDkwBA;ECjwBA;IACE,WAAA;EDmwBF;ECjwBA;IACE,OAAA;EDmwBF;EClwBE;IACE,cAAA;EDowBJ;ECjwBA;IACE,UAAA;IACA,aAAA;EDmwBF;EClwBE;IACE,UAAA;IACA,YAAA;EDowBJ;EClwBE;IACE,UAAA;IACA,QAAA;EDowBJ;AACF;;AGzxBE;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gGAAA;AH4xBJ;;AGvxBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AH0xBF;;AGtxBE;EACE,iBAAA;EACA,oBAAA;AHyxBJ;AGrxBQ;EACE,kBAAA;EACA,yBD1BS;AFizBnB;AGrxBU;EACE,iBAAA;EACA,oBAAA;AHuxBZ;AGlxBI;EACE,qBAAA;EACA,cDzCU;AF6zBhB;AGnxBM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AHqxBR;AGnxBM;EACE,cDjDU;AFs0BlB;AGlxBI;EACE,eAAA;AHoxBN;AGnxBM;EACE,cDvDU;AF40BlB;AGlxBM;EACE,UAAA;EACA,wBAAA;AHoxBR;AGlxBM;EACE,aAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;AHoxBR;AGjxBM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AHmxBR;AGjxBQ;EACE,aAAA;EACA,cD9EQ;AFi2BlB;AGjxBQ;EACE,kBAAA;EACA,eAAA;EACA,WD/EE;ECgFF,eDhFE;ECiFF,YDjFE;ECkFF,iBDlFE;ECmFF,kBAAA;EACA,qBAAA;AHmxBV;AGjxBU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AHmxBZ;AG/wBQ;EACE,YAAA;EACA,cAAA;AHixBV;AG5wBQ;EACE,cD1GQ;AFw3BlB;AG5wBY;EACE,6CAAA;AH8wBd;AGtwBU;EACE,mBDzHI;AFi4BhB;AGrwBU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AHuwBZ;AGrwBY;EACE,qBAAA;EACA,mBAAA;EACA,qBDrIE;ECsIF,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AHuwBd;AGhwBY;EACE,kCAAA;AHkwBd;AG/vBc;EACE,wBAAA;AHiwBhB;AG3vBQ;EACE,kBDrJO;AFk5BjB;AG3vBU;EACE,0BAAA;AH6vBZ;AG3vBY;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AH6vBd;AGrvBM;EACE,aAAA;AHuvBR;AG3uBU;EACE,yBDvLI;AFo6BhB;AGpuBU;EACE,gBAAA;AHsuBZ;AG9tBU;EACE,kBAAA;AHguBZ;AGxtBU;EACE,kBAAA;AH0tBZ;AG9sBQ;EAWE,kBAAA;AHssBV;AG/sBY;;EAEE,UAAA;AHitBd;AG9sBU;EACE,yBDxOiB;ECyOjB,YAAA;AHgtBZ;AG7sBU;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AH+sBZ;AG7sBU;EACE,kBAAA;AH+sBZ;AG7sBY;EACE,oBAAA;AH+sBd;AG7sBc;EACE,aAAA;AH+sBhB;AG5sBY;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AH8sBd;AG7sBc;EACE,kBAAA;AH+sBhB;AG7sBc;EACE,iBAAA;EACA,gBAAA;EACA,yBD/Qa;ECgRb,kBAAA;EACA,kBAAA;AH+sBhB;AG3sBc;EACE,sCAAA;EACA,mBAAA;AH6sBhB;AG1sBgB;EACE,6CAAA;AH4sBlB;AGtsBc;;EAEE,yBAAA;AHwsBhB;AG3rBQ;EACE,eAAA;EACA,gBAAA;AH6rBV;AG3rBQ;EACE,0BAAA;AH6rBV;AG5rBU;EACE,eAAA;EACA,iBAAA;AH8rBZ;AGxrBY;EACE,WAAA;EACA,UAAA;AH0rBd;AGzrBc;EACE,yBAAA;AH2rBhB;AGprBgB;EACE,wBAAA;AHsrBlB;AGhrBU;EACE,eAAA;EACA,mBD/UK;AFigCjB;AGhrBY;EACE,0BAAA;AHkrBd;AGjrBc;EACE,eAAA;EACA,iBAAA;AHmrBhB;AGrqBc;EACE,eAAA;EACA,kBAAA;AHuqBhB;AGtqBgB;EACE,mBAAA;AHwqBlB;AGtqBgB;EACE,eAAA;EACA,mBAAA;AHwqBlB;AGnqBgB;;EAEE,yBAAA;AHqqBlB;;AIhiCA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;AJmiCF;;AIhiCA;EACE,QAAA;EACA,+BAAA;AJmiCF;;AIhiCA;EACE,OAAA;EACA,8BAAA;AJmiCF;;AKnjCA;EACE,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;ALsjCF;;AKnjCA;EACE,kBAAA;ALsjCF;;AKnjCA;EACE,aAAA;ALsjCF;;AA5jCA;EAEI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA8jCJ;;AA3jCA;EAEG,yDAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA6jCH;;AAzjCA;EAEI,eMsBM;ENrBN,sBMxBU;ENyBV,gBAAA;EACA,gBM0Bc;ENzBd,WMvBI;ANklCR;;AAxjCA;EAEI,eMeM;ENdN,sBMjCU;ENkCV,gBMmBc;ENlBd,iBAAA;EACA,WMhCI;ENiCJ,yBAAA;AA0jCJ;;AAvjCA;EAEI,eMEM;ENDN,sBM3CU;EN4CV,gBMQc;ENPd,iBAAA;EACA,WM1CI;ANmmCR;;AAtjCA;EAEA,eAAA;EACC,cMzCO;EN0CP,4BAAA;EACA,eMXS;ANmkCV;;AArjCA;EAEC,2BAAA;EACA,eMpBS;ENqBT,WM9CM;ANqmCP;;AAnjCA;EAEI,eMjCM;ENkCN,WMrDG;ENsDH,2BAAA;AAqjCJ;;AAljCA;EAEI,eMxCM;ENyCN,WM5DG;EN6DH,2BAAA;AAojCJ;;AAjjCA;EAEI,eM/CM;ENgDN,cMpEG;ENqEH,2BAAA;AAmjCJ;;AAhjCA;EAEI,eM/CM;ANimCV;;AA/iCA;EAEI,aAAA;AAijCJ;;AA9iCA;EAEI,qBAAA;AAgjCJ;;AA5iCA;EAEI,cM7FI;AN2oCR;;AAxiCA;EAEI,cMrGI;ENsGJ,2BAAA;AA0iCJ;;AAviCA;EAEI,WAAA;AAyiCJ;;AAtiCA;EAEI,WAAA;AAwiCJ;;AAriCA;EAEI,2BAAA;EACA,uBAAA;AAuiCJ;;AApiCA;EAGI,uBAAA;EACA,YAAA;EACA,sDAAA;AAqiCJ;;AAjiCA;EAEI,oCAAA;EACA,sCAAA;EACA,wCAAA;EACA,2CAAA;EACA,0CAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;EACA,6BAAA;AAmiCJ;;AAhiCA;EAEI,oCAAA;EACA,sCAAA;EACA,wCAAA;EACA,2CAAA;EACA,0CAAA;EACA,cAAA;EACA,WAAA;AAkiCJ;;AA/hCA;EAEI,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EAEA,YAAA;EACA,kBAAA;AAgiCJ;;AA7hCA;EACI;IAEI,YAAA;IACA,gBAAA;IACA,kBAAA;EA+hCN;EA5hCC;IAED,aAAA;EA6hCA;EA3hCC;IAEC,gBAAA;IACA,cMpLI;INqLJ,2BAAA;IACA,eMtJM;ENkrCR;EA1hCE;IAEQ,2BAAA;IACA,cAAA;EA2hCV;EArhCC;IAEC,8BAAA;EAshCF;EAphCC;IAEC,eAAA;EAqhCF;AACF","sourcesContent":["@keyframes swing {\n  0%,\n  30%,\n  50%,\n  70%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(10deg);\n  }\n\n  40% {\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  80% {\n    transform: rotate(-5deg);\n  }\n}\n","@import \"../../../Assets/Scss/veriables.scss\";\n@import \"~react-pro-sidebar/dist/scss/styles.scss\";@import \"../../../Assets/Scss/veriables.scss\";\n@import \"~react-pro-sidebar/dist/scss/styles.scss\";\n\n\n\n.login_height\n{\n    height: 100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-top: 5%;\n}\n\n.background_image_login\n{\n   background-image: url('../../../Assets/Images/banner.png');\n   height: 100vh;\n   background-size: cover;\n   background-position: center;\n   background-repeat: no-repeat;\n\n}\n\n.heading_login\n{\n    font-size: $font-32;\n    font-family: $font-family;\n    padding-top: 12%;\n    font-weight: $font-weight-400;\n    color: $white;\n}\n\n.heading2_login\n{\n    font-size: $font-50;\n    font-family: $font-family;\n    font-weight: $font-weight-500;\n    line-height: 115%;\n    color: $white;\n    text-transform: uppercase;\n}\n\n.heading3_login\n{\n    font-size: $font-28;\n    font-family: $font-family;\n    font-weight: $font-weight-400;\n    line-height: 115%;\n    color: $white;\n}\n\n.heading4_login\n{\npadding-top: 5%;\n color: $black;\n font-weight: 1000 !important;\n font-size: $font-26;\n}\n\n.heading5_login\n{\n font-weight: $font-weight-400 !important;\n font-size: $font-20;\n color: $gray;\n}\n\n\n.label_login\n{\n    font-size: $font-12;\n    color: $gray;\n    font-weight: $font-weight-400 !important;\n}\n\n.join_login\n{\n    font-size: $font-12;\n    color: $gray;\n    font-weight: $font-weight-400 !important;\n}\n\n.join2_login\n{\n    font-size: $font-12;\n    color: $blue;\n    font-weight: $font-weight-400 !important;\n}\n\n.button_linkedin\n{\n    font-size: $font-22\n}\n\n.mob_logo\n{\n    display: none;\n}\n\n.link_decoration\n{\n    text-decoration: none;\n    \n}\n\n.text_color_line\n{\n    color: $black;\n    // font-size: 10px;\n\n}\n\n\n.right_arrow_login1\n{\n    color: $black;\n    font-weight: $font-weight-300 !important;\n}\n\n.img_width_login\n{\n    width: 100%;\n}\n\n.img_bulb_width\n{\n    width: 3.5%;\n}\n\n.button_style_forget\n{\n    border: 1px solid lightgray;\n    background-color: white;\n}\n\n.button_style_forget:hover\n{\n\n    background-color: white;\n    border: none;\n    box-shadow: 4px 4px 6px 6px rgba(128, 128, 128, 0.213);\n}\n\n\n.custom_button_forget\n{\n    background-color: #25224A !important;\n    border-top-left-radius: 1px !important;\n    border-top-right-radius: 10px !important;\n    border-bottom-right-radius: 10px !important;\n    border-bottom-left-radius: 10px !important;\n    font-size: 80%;\n    width: 100%;\n    padding: 10px 10px !important;\n    border-top-right-radius: 10px;\n}\n\n.custom_button_forget:hover\n{\n    background-color: #25224A !important;\n    border-top-left-radius: 1px !important;\n    border-top-right-radius: 10px !important;\n    border-bottom-right-radius: 10px !important;\n    border-bottom-left-radius: 10px !important;\n    font-size: 80%;\n    width: 100%;\n}\n\n.mobile_padding_bottom_forget\n{\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n   \n    color: white;\n    text-align: center;\n}\n\n@media screen and (max-width: 980px) {\n    .login_height\n    {\n        height: auto;\n        overflow-y: auto;\n        overflow-x: hidden;\n    }\n\n   .background_image_login\n   {\n  display: none;\n   }\n   .heading4_login\n    {\n    padding-top: 20%;\n    color: $black;\n    font-weight: $font-weight-700 !important;\n    font-size: $font-26;\n    }\n    .mob_logo\n        {\n            padding-top: 30% !important;\n            display: block;\n        }\n\n\n\n\n   .mobile_padding_bottom\n   {\n    padding-bottom: 15% !important;\n   }\n   .button_style_forget\n   {\n    margin-top: 30%;\n   }\n  }","@mixin break-point {\n  position: fixed;\n  left: -$sidebar-width;\n  &.collapsed {\n    left: -$sidebar-collapsed-width;\n  }\n  &.toggled {\n    left: 0;\n    .overlay {\n      display: block;\n    }\n  }\n  &.rtl {\n    left: auto;\n    right: -$sidebar-width;\n    &.collapsed {\n      left: auto;\n      right: -$sidebar-collapsed-width;\n    }\n    &.toggled {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n.pro-sidebar {\n  color: $sidebar-color;\n  height: 100%;\n  width: $sidebar-width;\n  min-width: $sidebar-width;\n  text-align: left;\n  transition: width, left, right, 0.3s;\n  position: relative;\n  z-index: 1009;\n  > .pro-sidebar-inner {\n    background: $sidebar-bg-color;\n    height: 100%;\n    position: relative;\n    z-index: 101;\n\n    > img.sidebar-bg {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n      position: absolute;\n      opacity: 0.3;\n      left: 0;\n      top: 0;\n      z-index: 100;\n    }\n\n    > .pro-sidebar-layout {\n      height: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      z-index: 101;\n\n      .pro-sidebar-header {\n        border-bottom: 1px solid rgba($sidebar-color, 0.2);\n      }\n      .pro-sidebar-content {\n        flex-grow: 1;\n      }\n      .pro-sidebar-footer {\n        border-top: 1px solid rgba($sidebar-color, 0.2);\n      }\n      ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(#000, 0.3);\n    z-index: 100;\n    display: none;\n  }\n\n  &.collapsed {\n    width: $sidebar-collapsed-width;\n    min-width: $sidebar-collapsed-width;\n  }\n\n  &.rtl {\n    text-align: right;\n    direction: rtl;\n  }\n\n  &.xs {\n    @media (max-width: $breakpoint-xs) {\n      @include break-point;\n    }\n  }\n  &.sm {\n    @media (max-width: $breakpoint-sm) {\n      @include break-point;\n    }\n  }\n  &.md {\n    @media (max-width: $breakpoint-md) {\n      @include break-point;\n    }\n  }\n  &.lg {\n    @media (max-width: $breakpoint-lg) {\n      @include break-point;\n    }\n  }\n  &.xl {\n    @media (max-width: $breakpoint-xl) {\n      @include break-point;\n    }\n  }\n  &.xxl {\n    @media (max-width: $breakpoint-xxl) {\n      @include break-point;\n    }\n  }\n}\n","$sidebar-bg-color: #1d1d1d !default;\n$sidebar-color: #adadad !default;\n$sidebar-width: 270px !default;\n$sidebar-collapsed-width: 80px !default;\n$highlight-color: #d8d8d8 !default;\n$submenu-bg-color: #2b2b2b !default;\n$submenu-bg-color-collapsed: #2b2b2b !default;\n$icon-bg-color: #2b2b2b !default;\n$icon-size: 35px !default;\n$submenu-indent: 24px !default;\n\n$breakpoint-xs: 480px !default;\n$breakpoint-sm: 576px !default;\n$breakpoint-md: 768px !default;\n$breakpoint-lg: 992px !default;\n$breakpoint-xl: 1200px !default;\n$breakpoint-xxl: 1600px !default;\n","%pro-item-prefix {\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    min-width: 4px;\n    height: 4px;\n    border: 1px solid $submenu-bg-color;\n    border-radius: 50%;\n    margin-right: 15px;\n    position: relative;\n    box-shadow: 1px 0px 0px $sidebar-color, 0px -1px 0px $sidebar-color, 0px 1px 0px $sidebar-color,\n      -1px 0px 0px $sidebar-color;\n  }\n}\n\n%text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pro-sidebar {\n  .pro-menu {\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n    > ul {\n      > .pro-sub-menu {\n        > .pro-inner-list-item {\n          position: relative;\n          background-color: $submenu-bg-color;\n\n          > div > ul {\n            padding-top: 15px;\n            padding-bottom: 15px;\n          }\n        }\n      }\n    }\n    a {\n      text-decoration: none;\n      color: $sidebar-color;\n      &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: transparent;\n      }\n      &:hover {\n        color: $highlight-color;\n      }\n    }\n    .pro-menu-item {\n      font-size: 15px;\n      &.active {\n        color: $highlight-color;\n      }\n\n      .suffix-wrapper {\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n      .prefix-wrapper {\n        display: flex;\n        margin-right: 5px;\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n\n      > .pro-inner-item {\n        position: relative;\n        display: flex;\n        align-items: center;\n        padding: 8px 35px 8px 20px;\n        cursor: pointer;\n\n        &:focus {\n          outline: none;\n          color: $highlight-color;\n        }\n        > .pro-icon-wrapper {\n          margin-right: 10px;\n          font-size: 14px;\n          width: $icon-size;\n          min-width: $icon-size;\n          height: $icon-size;\n          line-height: $icon-size;\n          text-align: center;\n          display: inline-block;\n\n          .pro-icon {\n            display: flex;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        > .pro-item-content {\n          flex-grow: 1;\n          flex-shrink: 1;\n\n          @extend %text-truncate;\n        }\n\n        &:hover {\n          color: $highlight-color;\n          .pro-icon-wrapper {\n            .pro-icon {\n              animation: swing ease-in-out 0.5s 1 alternate;\n            }\n          }\n        }\n      }\n\n      &.pro-sub-menu {\n        > .pro-inner-item {\n          &:before {\n            background: $sidebar-color;\n          }\n\n          > .pro-arrow-wrapper {\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            .pro-arrow {\n              display: inline-block;\n              border-style: solid;\n              border-color: $sidebar-color;\n              border-width: 0 2px 2px 0;\n              padding: 2.5px;\n              vertical-align: middle;\n              transition: transform 0.3s;\n              transform: rotate(-45deg);\n            }\n          }\n        }\n\n        &.open {\n          > .pro-inner-item {\n            &:before {\n              background: transparent !important;\n            }\n            > .pro-arrow-wrapper {\n              .pro-arrow {\n                transform: rotate(45deg);\n              }\n            }\n          }\n        }\n\n        .pro-inner-list-item {\n          padding-left: $submenu-indent;\n\n          .pro-inner-item {\n            padding: 8px 30px 8px 15px;\n\n            > .pro-icon-wrapper {\n              background: none;\n              width: auto;\n              min-width: auto;\n              height: auto;\n              line-height: auto;\n            }\n          }\n        }\n      }\n    }\n\n    &:not(.inner-submenu-arrows) {\n      .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {\n        display: none;\n      }\n    }\n    &.submenu-bullets {\n      .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {\n        @extend %pro-item-prefix;\n      }\n    }\n\n    &.shaped {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            background-color: $icon-bg-color;\n          }\n        }\n      }\n    }\n\n    &.square {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 0;\n          }\n        }\n      }\n    }\n    &.round {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n    &.circle {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n\n  // styling when the sidebar is collapsed\n\n  &.collapsed {\n    .pro-menu {\n      > ul {\n        > .pro-menu-item {\n          > .pro-inner-item {\n            > .suffix-wrapper,\n            > .prefix-wrapper {\n              opacity: 0;\n            }\n          }\n          > .pro-inner-list-item {\n            background-color: $submenu-bg-color-collapsed;\n            z-index: 111;\n          }\n          position: relative;\n          &::before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            cursor: pointer;\n          }\n          &.pro-sub-menu {\n            position: relative;\n\n            > .pro-inner-item {\n              pointer-events: none;\n\n              > .pro-arrow-wrapper {\n                display: none;\n              }\n            }\n            > .pro-inner-list-item {\n              height: auto !important;\n              position: fixed;\n              visibility: hidden;\n              min-width: 220px;\n              max-width: 270px;\n              background-color: transparent;\n              max-height: 100%;\n              padding-left: 3px;\n              &.has-arrow {\n                padding-left: 10px;\n              }\n              > .popper-inner {\n                max-height: 100vh;\n                overflow-y: auto;\n                background-color: $submenu-bg-color-collapsed;\n                padding-left: 20px;\n                border-radius: 4px;\n              }\n            }\n            &:hover {\n              > .pro-inner-list-item {\n                transition: visibility, transform 0.3s;\n                visibility: visible;\n              }\n              .pro-icon-wrapper {\n                .pro-icon {\n                  animation: swing ease-in-out 0.5s 1 alternate;\n                }\n              }\n            }\n\n            .pro-inner-list-item {\n              .pro-sub-menu-item,\n              .pro-inner-item {\n                padding: 8px 30px 8px 5px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // styles for rtl\n  &.rtl {\n    .pro-menu {\n      .pro-menu-item {\n        .prefix-wrapper {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n        > .pro-inner-item {\n          padding: 8px 20px 8px 35px;\n          > .pro-icon-wrapper {\n            margin-right: 0;\n            margin-left: 10px;\n          }\n        }\n\n        &.pro-sub-menu {\n          > .pro-inner-item {\n            > .pro-arrow-wrapper {\n              right: auto;\n              left: 20px;\n              .pro-arrow {\n                transform: rotate(135deg);\n              }\n            }\n          }\n          &.open {\n            > .pro-inner-item {\n              > .pro-arrow-wrapper {\n                .pro-arrow {\n                  transform: rotate(45deg);\n                }\n              }\n            }\n          }\n\n          .pro-inner-list-item {\n            padding-left: 0;\n            padding-right: $submenu-indent;\n\n            .pro-inner-item {\n              padding: 8px 15px 8px 30px;\n              &:before {\n                margin-right: 0;\n                margin-left: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // styles for rtl and collapsed\n    &.collapsed {\n      .pro-menu {\n        > ul {\n          > .pro-menu-item {\n            &.pro-sub-menu {\n              > .pro-inner-list-item {\n                padding-left: 0;\n                padding-right: 3px;\n                &.has-arrow {\n                  padding-right: 10px;\n                }\n                > .popper-inner {\n                  padding-left: 0;\n                  padding-right: 20px;\n                }\n              }\n\n              .pro-inner-list-item {\n                .pro-sub-menu-item,\n                .pro-inner-item {\n                  padding: 8px 5px 8px 30px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".popper-arrow {\n  position: absolute;\n  z-index: -1;\n  width: 0;\n  height: 0;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.popper-element[data-popper-placement^='left'] > .popper-arrow {\n  right: 0;\n  border-right: 7px solid $submenu-bg-color-collapsed;\n}\n\n.popper-element[data-popper-placement^='right'] > .popper-arrow {\n  left: 0;\n  border-left: 7px solid $submenu-bg-color-collapsed;\n}\n",".react-slidedown {\n  height: 0;\n  transition-property: none;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.react-slidedown.transitioning {\n  overflow-y: hidden;\n}\n\n.react-slidedown.closed {\n  display: none;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$font-family: \"Poppins\" !default;\n$font-family-Roboto: \"Roboto\" !default;\n$font-family-Dosis: \"Dosis\" !default;\n\n$white: #fff !default;\n$light-gray: rgba(255, 255, 255, 0.5) !default;\n\n$red: #d41313 !default;\n\n$primary: #0575E6 !default;\n\n$black: #131313 !default;\n$light-black: #201f23 !default;\n$dark-black: #0e0e0e !default;\n$blue: #0575E6 !default;\n$gray: Gray !default;\n$lightgray: lightgray !default;\n$green: #42D742 !default;\n\n\n$border: 1px solid #D1D1D1 !default;\n$bold-border: 3px solid #b59b41 !default;\n\n$border-radius-10: 10px !default;\n$border-radius-20: 20px !default;\n$border-radius-24: 24px !default;\n\n$text-uppercase: uppercase !default;\n\n\n$font-8: 8px !default;\n$font-9: 9px !default;\n$font-10: 10px !default;\n$font-11: 11px !default;\n$font-12: 12px !default;\n$font-14: 14px !default;\n$font-15: 15px !default;\n$font-16: 16px !default;\n$font-17: 17px !default;\n$font-18: 18px !default;\n$font-20: 20px !default;\n$font-22: 22px !default;\n$font-24: 24px !default;\n$font-26: 26px !default;\n$font-28: 28px !default;\n$font-32: 32px !default;\n$font-36: 36px !default;\n$font-50: 50px !default;\n$font-40: 40px !default;\n$font-144: 144px !default;\n\n$font-weight-300: 300 !default;\n$font-weight-400: 400 !default;\n$font-weight-500: 500 !default;\n$font-weight-600: 600 !default;\n$font-weight-700: 700 !default;\n$font-weight-800: 800 !default;\n$font-weight-900: 900 !default;\n$font-weight-1200: 1900 !default;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
